import api from "./base-api"

const bermudaStateApiV1 = api.injectEndpoints({
    endpoints: (build) => ({
        getStateV1BA: build.query({
            query: (userId = "") => `v1/bermuda/states/${userId}`
        })
    }),
    overrideExisting: false
})

export const {
    useGetStateV1BAQuery
} = bermudaStateApiV1

const bermudaStateApiV2 = api.injectEndpoints({
    endpoints: (build) => ({
        getStateV2BA: build.query({
            query: ({deviceId, stateId}) => {
                return `v2/bermuda/states/${deviceId}/${stateId}`
            },
            providesTags: ['UserStates']
        }),
        getStatesByFacebookIdV2BA: build.query({
            query: (facebookId = "") => `v2/bermuda/states/facebook/${facebookId}`
        }),
        createStateV2BA: build.mutation({
            query: (data) => {
                const {userId, game, ...body} = data


                return {
                    url: `v2/bermuda/states/${game}/${userId}`,
                    method: "POST",
                    body: body.body
                }
            },
            invalidatesTags: ['UserStates']
        }),
        clearData: build.mutation({
            query: () => null,
            onQueryStarted: (arg, {dispatch, queryFulfilled}) => {
                dispatch(clearData())
                queryFulfilled(undefined, {data: null})
            },
        }),
        checkExist: build.mutation({
            query: (body = {}) => ({
                url: `v2/bermuda/states/exist`,
                method: "POST",
                body: body
            }),
        }),
        advancedSearchBA: build.mutation({
            query: (body = {}) => ({
                url: `v2/bermuda/states/advancedSearch`,
                method: "POST",
                body: body
            }),
        }),
    }),
    overrideExisting: false
})

export const {
    useGetStateV2BAQuery,
    useGetStatesByFacebookIdV2BAQuery,
    useCreateStateV2BAMutation,
    useAdvancedSearchBAMutation,
    clearData,
    useCheckExistMutation
} = bermudaStateApiV2
